import { Text } from "@/components/ui/baseUi/text"
import { useCurrentBox } from "@/modules/box/hooks/useBox"
import { useBoxSlotGetSession } from "@/modules/boxSlotSession/hooks/useBoxSlotGetSession"
import { cn } from "@/modules/lib/utils"
import { FullscreenExerciseDetails } from "@/modules/sessions/sessionDetails/components/fullscreenExerciseDetails"
import { SessionBlockType } from "@/modules/sessions/sessionDetails/sessionBlockTypes"
import { HustleupIcon } from "@images/hustleupIcon"
import { CardioSelectedIcon } from "@images/svgIcons/cardioIcon"
import { GymSelectedIcon } from "@images/svgIcons/gymIcon"
import { WeightliftingSelectedIcon } from "@images/svgIcons/weightliftingIcon"
import { ProfileAvatar } from "@modules/profile/common/components/profileAvatar"

type BoxSlotSessionContentDetailsFullscreenProps = {
  boxSessionId: string
} & React.ComponentProps<"div">

export function BoxSlotSessionContentDetailsFullscreen({
  boxSessionId,
  className,
  ...props
}: BoxSlotSessionContentDetailsFullscreenProps) {
  const { result: box } = useCurrentBox()
  const { data: boxSession } = useBoxSlotGetSession(boxSessionId)

  return (
    <div className={cn("flex h-screen flex-col overflow-hidden", className)} {...props}>
      <div className="flex flex-1 flex-col overflow-auto p-12" style={{ height: "calc(100vh - 30px)" }}>
        <div className="flex">
          <ProfileAvatar profile={{ avatar: box?.logo ?? null, username: box?.name ?? "" }} />
          <div className="flex-1 content-center pl-8">
            <Text fontStyle="HL">{boxSession.name}</Text>
            <div className="mt-2 flex flex-row items-center justify-start gap-6">
              {boxSession.gymnasticTag && <GymSelectedIcon color="" width={25} height={25} />}
              {boxSession.weightliftingTag && <WeightliftingSelectedIcon color="" width={25} height={25} />}
              {boxSession.cardioTag && <CardioSelectedIcon color="" width={30} height={30} />}
            </div>
          </div>
        </div>
        <div className="flex flex-1 gap-8 pt-12">
          {boxSession.blocks
            .filter((block) => block.type === SessionBlockType.SESSION_EXERCISE)
            .map((block, key) => (
              <FullscreenExerciseDetails key={key} exercise={block.content} />
            ))}
        </div>
      </div>
      <div className="mb-1 flex" style={{ height: 30 }}>
        <HustleupIcon
          color="currentColor"
          width={160}
          style={{ margin: "auto" }}
          className="text-textDefault-heading"
        />
      </div>
    </div>
  )
}
